import { render, staticRenderFns } from "./DocumentEditor.vue?vue&type=template&id=fabae3b4&scoped=true&"
import script from "./DocumentEditor.vue?vue&type=script&lang=js&"
export * from "./DocumentEditor.vue?vue&type=script&lang=js&"
import style0 from "./DocumentEditor.vue?vue&type=style&index=0&id=fabae3b4&prod&lang=css&"
import style1 from "./DocumentEditor.vue?vue&type=style&index=1&id=fabae3b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fabae3b4",
  null
  
)

export default component.exports